import styled, { css } from 'styled-components';
import { animated } from '@react-spring/web';

export const Wrapper = styled.section`
    ${({ theme }) => css`
        position: relative;
        background: linear-gradient(to bottom, lightgrey, white);
        height: 29rem;
        padding-bottom: 7.5rem;
        overflow: hidden;

        @media ${theme.breakpoints.large.media} {
            height: 40rem;
            padding-bottom: 3.5rem;
        }

        @media ${theme.breakpoints.xlarge.media} {
            height: 45rem;
            padding-bottom: 3.5rem;
        }
    `}
`;

export const Container = styled.div`
    ${({ theme }) => css`
        position: relative;
        height: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;

        &:after {
            content: '';
            background: linear-gradient(to bottom, rgba(255, 255, 255, 0), white);
            height: 5rem;
            position: absolute;
            left: 0;
            right: 0;
            z-index: 5;
            bottom: -7.5rem;

            @media ${theme.breakpoints.medium.media} {
                bottom: -7.5rem;
            }

            @media ${theme.breakpoints.large.media} {
                bottom: -3.5rem;
            }
        }
    `}
`;

export const Layer = styled(animated.div)<{ $zIndex?: number }>`
    ${({ $zIndex, theme }) => css`
        position: absolute;
        max-width: 120rem;
        width: 130%;
        height: 100%;

        ${$zIndex &&
        css`
            z-index: ${$zIndex};
        `}

        @media ${theme.breakpoints.medium.media} {
            width: 100%;
            height: 100%;
        }
    `}
`;

export const FeatureLayerWrapper = styled.div`
    ${({ theme }) => css`
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    `}
`;

export const FeatureLayer = styled(animated.div)<{ $zIndex?: number }>`
    ${({ $zIndex, theme }) => css`
        margin: 0 auto;
        position: absolute;
        width: 12.25rem;
        height: 12.75rem;
        top: 4.75rem;
        display: block;

        ${$zIndex &&
        css`
            z-index: ${$zIndex};
        `}

        @media ${theme.breakpoints.medium.media} {
            position: absolute;
            width: 13rem;
            height: 17rem;
            top: 12%;
        }

        @media ${theme.breakpoints.large.media} {
            position: absolute;
            width: 20rem;
            height: 22rem;
            top: 12%;
        }

        @media ${theme.breakpoints.xlarge.media} {
            width: 21rem;
            height: 23rem;
            top: 12%;
        }

        @media ${theme.breakpoints.huge.media} {
            width: 23rem;
            height: 25rem;
            top: 10%;
        }
    `}
`;

export const Heading = styled(animated.h1)`
    ${({ theme }) => css`
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        transform: translateX(-50%);
        line-height: 0.9;
        font-size: 8.5rem;
        font-weight: 900;
        color: ${theme.colors.primary.hex};
        left: 50%;
        z-index: 5;
        margin: 3.25rem 0 0;

        @media ${theme.breakpoints.medium.media} {
            font-size: 8.5rem;
            margin: 5.25rem 0 0;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 12.5rem;
            margin: 6.75rem 0 0;
        }

        @media ${theme.breakpoints.xlarge.media} {
            font-size: 12.5rem;
            margin: 7.25rem 0 0;
        }

        @media ${theme.breakpoints.huge.media} {
            margin: 7.75rem 0 0;
        }
    `}
`;

export const Text = styled(animated.p)`
    ${({ theme }) => css`
        position: absolute;
        font-family: ${theme.fonts.primary};
        font-size: 1rem;
        line-height: 1.2;
        text-align: center;
        font-weight: bold;
        margin: 0;
        z-index: 6;
        padding: 0 0.75rem;
        max-width: unset;
        color: ${theme.colors.text.hex};
        bottom: -1rem;

        @media ${theme.breakpoints.small.media} {
            bottom: -0.75rem;
        }

        @media ${theme.breakpoints.smallLarge.media} {
            bottom: -1.75rem;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 32rem;
            min-width: 32rem;
        }

        @media ${theme.breakpoints.medium.media} {
            bottom: -3.5rem;
            font-size: 1.25rem;
        }

        @media ${theme.breakpoints.large.media} {
            bottom: 4rem;
        }
    `}
`;

export const Subheading = styled.span`
    ${({ theme }) => css`
        font-family: ${theme.fonts.primary};
        text-transform: uppercase;
        text-align: center;
        font-size: 2.5vw;
        font-size: clamp(1.25rem, 2.5vw, 2.5rem);
        white-space: nowrap;
    `}
`;

export const LinkWrapper = styled.div`
    ${({ theme }) => css`
        display: none;
        position: absolute;
        max-width: 17.5rem;
        top: 1.75rem;
        right: 1.75rem;
        z-index: 5;

        svg {
            width: 1.5rem;
            height: 1.5rem;
            stroke-width: 0.1875rem;
        }

        & :hover {
            border-radius: 5rem;
            transition: border-radius ease 0.5s;
        }

        @media ${theme.breakpoints.large.media} {
            display: block;
        }
    `}
`;
